// Legacy 301: /sobre → /quienes-somos
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/sobre")({
  beforeLoad: () => {
    throw redirect({ to: "/quienes-somos", statusCode: 301 } as never);
  },
  component: () => null,
});
